import { z } from 'zod';

export const TTSConfigValidator = z.object({
  languages: z.record(z.string(), z.string().min(5)),
  fallbackLanguage: z.string(),
});

export type TTSConfig = z.infer<typeof TTSConfigValidator>;
